import { createSelector } from 'reselect';
import qs from 'qs';
import {
  groupBy,
  map,
  toPairs,
} from 'lodash/fp';
import {
  dataFormatSelector,
  dataSelector,
  geographySelector,
  precisionSelector,
} from 'selectors/indicator';
import config from 'config/chartConfig';
import statePostalFips from 'config/statePostalFips';
import { timeframeAll } from './timeframe';

const generateChartData = (
  dataFormat,
  precision,
  data,
  geographies,
  timeframes,
  { state, ownProps },
) => {
  const { data: { chartColorsUsed: colors, seriesAdd } } = state;
  const { geos: activeGeos = 'US' } = qs.parse(
    ownProps.location.search,
    { ignoreQueryPrefix: true }
  );
  const geos = ('' === activeGeos) ? [] :
    map((postal) =>
      statePostalFips.find(([code]) => postal === code)[1]
    )(activeGeos.split(','));
  const filteredData = data.filter(({ geography }) =>
    -1 < geos.indexOf(geographies[geography].code));
  const pairedData = toPairs(groupBy('geography', filteredData));
  const formattedData = pairedData
    .map(([geoId, datum]) => ({
      name: geographies[geoId].geography,
      geography: geographies[geoId].geography,
      postal: statePostalFips.find(([, code]) =>
        code === geographies[geoId].code)[0],
      data: datum.map((item) => ({
        item: {
          ...item,
          geography: geographies[item.geography].geography,
        },
        y: item.value,
        value: item.timeframe.value,
        name: item.timeframe.label, // Using the category setting of highcharts
      })).sort(({ value: a }, { value: b }) => a - b),
    }));
  return {
    ...config,
    colors,
    series: formattedData.map((datum) => ({
      ...datum,
      animation: datum.postal === seriesAdd ? { duration: 1000 } : false,
      color: colors[datum.postal],
    })),
    xAxis: {
      ...config.xAxis,
      categories: timeframes
        .sort(({ value: a }, { value: b }) => a - b)
        .map(({ label }) => label),
    },
    yAxis: {
      ...config.yAxis,
      labels: {
        formatter() {
          return 'percent' === dataFormat ?
            `${(this.value * 100).toFixed(precision)}%` :
            this.value;
        },
      },
    },
  };
};

export default createSelector(
  dataFormatSelector,
  precisionSelector,
  dataSelector,
  geographySelector,
  timeframeAll,
  (state, ownProps) => ({ state, ownProps }),
  generateChartData
);



// WEBPACK FOOTER //
// ./app/selectors/indicator/chart.js